export default __webpack_public_path__ + "static/media/1.915412f7.jpg";